import { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import Tours from "@/components/site/Tours";
import Story from "@/components/site/Story";
import Journal from "@/components/site/Journal";
import Gallery from "@/components/site/Gallery";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

const Index = () => {
  useEffect(() => {
    const flagged = sessionStorage.getItem("scrollToContact");
    if (flagged || window.location.hash === "#contact") {
      sessionStorage.removeItem("scrollToContact");
      window.setTimeout(() => {
        const contact = document.getElementById("contact");
        if (!contact) return;
        contact.scrollIntoView({ behavior: "smooth", block: "start" });
        window.setTimeout(() => {
          const firstField = contact.querySelector<HTMLInputElement>(
            "input, select, textarea"
          );
          firstField?.focus({ preventScroll: true });
        }, 700);
      }, 100);
    }
  }, []);

  return (
    <main>
      <Nav />
      <Hero />
      <Tours />
      <Story />
      <Journal />
      <Gallery />
      <Faq />
      <Contact />
      <Footer />
    </main>
  );
};

export default Index;
